import { Box, styled } from "@mui/material";

/** Wrapper for cells of OverviewTableRow, should be used for most cells */
export const OverviewTableCell = styled(Box)({
  display: "table-cell",
  padding: "0 20px",
});
